import * as React from 'react';
import { useState } from 'react';
import {
	Button,
	Datagrid,
	DateField,
	NumberField,
	ReferenceField,
	TextField,
	useRecordContext
} from 'react-admin';
import { Drawer } from '@material-ui/core';
import { ExportField } from '../util/Exporter';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import Edit from '@material-ui/icons/Edit';
import { MarathonWeightingEdit } from './MarathonWeightingEdit';

export const exportFields: ExportField[] = [
	{ key: 'fullName', header: 'שם מלא' },
	{ key: 'user.phone.phone', header: 'מספר טלפון' },
	{ key: 'birthDate', header: 'תאריך לידה' },
	{ key: 'gender', header: 'מגדר' },
	{ key: 'city.name', header: 'עיר/ישוב' },
	{ key: 'neighborhood.name', header: 'שכונה' },
	{ key: 'street', header: 'רחוב' }
];

export const MarathonWeightingsDatagrid = ({ rootId, showDate = true }) => {
	const record = useRecordContext();

	console.log(record);

	return <div className="marathon-weightings">
		<Datagrid>
			<TextField source="id" label="#"/>
			<ReferenceField source="traineeId" reference="trainees" label="TRAINEE">
				<TextField source="fullName"/>
			</ReferenceField>
			<DateField showTime source="_createdAt" label="CREATED_AT"/>
			<NumberField source="marathonDayNumber" label="MARATHON_DAY_NUMBER"/>
			<TextField source="weight" label="WEIGHT"/>
			<EditMarathonWeightingButton/>
		</Datagrid>
	</div>;
};

const EditMarathonWeightingButton = () => {
	const weighting = useRecordContext();

	const [showPanel, setShowPanel] = useState(false);

	const handleClick = (event) => {
		event.stopPropagation();
		event.preventDefault();
		setShowPanel(true);
	};

	const handleCloseClick = (event) => {
		event.stopPropagation();
		event.preventDefault();
		setShowPanel(false);
	};

	return (
		<>
			<Button onClick={handleClick} label={weighting.title}>
				<Edit/>
			</Button>
			<Drawer anchor="right" open={showPanel} onClose={handleCloseClick}>
				<div>
					<Button label="CLOSE" onClick={handleCloseClick}>
						<KeyboardArrowRight/>
					</Button>
				</div>
				<MarathonWeightingEdit resource="weightings" basePath="weightings" id={weighting.id.toString()}/>
			</Drawer>
		</>
	);
};

